import ClubFeeCategory from './ClubFeeCategory';
import ClubImpersonalAccount from './ClubImpersonalAccount';
import Department from './Department';
import PricePerTime from './PricePerTime';

export default class ClubSalesListItem {
    static fromData(data) {
        if (!data) {
            return;
        }

        let clubSalesListItem = new ClubSalesListItem();
        clubSalesListItem.id = data.id;
        clubSalesListItem.name = data.name;
        clubSalesListItem.department = null !== data.department ? Department.fromData(data.department) : null;
        clubSalesListItem.category = null !== data.category ? ClubFeeCategory.fromData(data.category) : null;
        clubSalesListItem.impersonalAccount = null !== data.impersonalAccount ? ClubImpersonalAccount.fromData(data.impersonalAccount) : null;
        clubSalesListItem.pricePerTime = PricePerTime.fromData(data.pricePerTime.data);
        clubSalesListItem.chargeCredit = data.chargeCredit;
        clubSalesListItem.count = null;

        return clubSalesListItem;
    }
}
